module.exports = __webpack_public_path__ + "r-v3/img/info.1adc8fad.svg";